import { Input } from '@/components/Input';
import { selectAbn, setAbn } from '@/context/borrower';
import { selectIsNZ } from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
    disabled?: boolean;
}

export const testId = 'Abn';

export function Abn({
    baseId,
    showErrors,
    disabled = true,
}: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectAbn);
    const isNZ = useAppSelector(selectIsNZ);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    const handleChange = (value: string): void => {
        dispatch(setAbn(value));
    };

    // ***** Render *****
    return (
        <div className='w-full' data-testid={testId}>
            <Input
                title={isNZ ? 'NZBN' : 'ABN'}
                placeholder={currentState || (isNZ ? 'Enter NZBN' : 'Required')}
                showErrors={showErrors && !currentState && !isNZ}
                id={`${baseId}-input-abn`}
                value={currentState ?? ''}
                disabled={disabled}
                onChange={handleChange}
                tooltipContent={
                    isNZ
                        ? 'if no NZBN, enter company number'
                        : 'Check this looks correct but if not, search using the Business Name again.'
                }
            />
        </div>
    );
}
